import { Box, Alert, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { AppLayout } from '@base/ui/layouts';
import { AppHeader } from '@base/ui/components';
import { useNavigationStore } from '../router/navigation-store';
import { useBackButton } from '../router/use-back-button';
import { ProductInfoCard } from './product-info-card';
import { TicketCard } from './ticket-card';
import { EmptyState } from './empty-state';
import { TicketCardSkeleton } from './ticket-card-skeleton';
import { useTicketListData, useTicketActions } from './ticket-list.hooks';

export function TicketListPage() {
  const urlParams = useNavigationStore((state) => state.urlParams);
  const { goBack } = useBackButton();

  const incidentId = urlParams?.incident_id || '';
  const { tickets, isLoading, isError, error, refetch } = useTicketListData(incidentId);
  const { viewTicket, editTicket, createTicket } = useTicketActions();

  return (
    <AppLayout
      header={
        <AppHeader
          title="Danh sách báo cáo lỗi"
          onBack={goBack}
        />
      }
      bottomBar={
        tickets.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              px: 2,
              py: 1,
              height: '100%',
              alignItems: 'center',
            }}
          >
            <Button
              variant="contained"
              fullWidth
              startIcon={<AddIcon />}
              onClick={createTicket}
              disabled={isLoading}
            >
              TẠO BÁO CÁO MỚI
            </Button>
          </Box>
        ) : undefined
      }
    >
      {/* Content */}
      <Box sx={{ p: 2, pb: 4 }}>
        {/* Product Info Card */}
        <ProductInfoCard />

        {/* Error State */}
        {isError && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            action={
              <Button color="inherit" size="small" onClick={() => refetch()}>
                Thử lại
              </Button>
            }
          >
            {error instanceof Error ? error.message : 'Không thể tải danh sách báo cáo'}
          </Alert>
        )}

        {/* Loading State */}
        {isLoading && (
          <>
            <TicketCardSkeleton />
            <TicketCardSkeleton />
            <TicketCardSkeleton />
          </>
        )}

        {/* Empty State */}
        {!isLoading && !isError && tickets.length === 0 && <EmptyState />}

        {/* Ticket List */}
        {!isLoading && !isError && tickets.length > 0 && (
          <Box>
            {tickets.map((ticket) => (
              <TicketCard
                key={ticket.name}
                ticket={ticket}
                onView={viewTicket}
                onEdit={editTicket}
              />
            ))}
          </Box>
        )}
      </Box>
    </AppLayout>
  );
}

